<template>
    <button
        ref="buttonEl"
        v-qa="'filter-button'"
        class="filter-button"
        type="button"
        @click="$emit('open-filters-modal')"
    >
        <img
            :src="filtersIcon"
            class="icon"
            :alt="t('catalogue.grid.filter')"
            width="20"
            height="20"
        />

        {{ t('catalogue.grid.filter') }}
        <span
            v-if="activeFilterCount"
            :data-qa-active-filter-count="activeFilterCount"
        >
            ({{ activeFilterCount }})
        </span>
    </button>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'
import { useI18n } from 'vue-i18n'

import filtersIcon from '@/assets/icons/filters.svg'

defineProps<{
    activeFilterCount: number
}>()

defineEmits<{
    'open-filters-modal': []
}>()

const buttonEl = useTemplateRef<HTMLButtonElement>('buttonEl')
defineExpose({ buttonEl })

const { t } = useI18n()
</script>

<style scoped lang="scss">
.filter-button {
    margin-right: 8px;
    cursor: pointer;

    .icon {
        vertical-align: top;
        margin-right: 8px;
    }
}
</style>
